import { IMessage, MessageType } from "@/protocols/channel"
import { UserInInstanceRoleName } from "@/protocols/userInInstance"
import { AttendanceSummaryDialogVariant } from "@/protocols/attendanceSummary"

const RELEVANT_ATTENDANCE_NOTIFICATION_TYPES: MessageType[] = [
	"attendance-assigned-notification",
	"attendance-finished-notification",
	"awakened-snooze-notification",
	"awakened-snooze-with-note-notification"
]

const ATTENDANCE_FINISHED_NOTIFICATION_TYPE: MessageType = "attendance-finished-notification"

const isRelevantAttendanceNotificationMessage = (message: IMessage): boolean => {
	const isNotificationMessage = message?.type?.includes("notification")

	if (!isNotificationMessage) {
		return false
	}

	const isRelevantNotificationType = RELEVANT_ATTENDANCE_NOTIFICATION_TYPES.includes(message.type)

	if (isRelevantNotificationType) {
		return true
	}

	const isObservationGeneratedViaAISummary = message.type === "attendance-assigned-observation-notification" &&
		Boolean(message.extraData?.notificationInfo?.hasAttendanceSummaryGeneratedByAI)

	return isObservationGeneratedViaAISummary
}

const isAttendanceFinishedNotificationMessage = (message: IMessage): boolean => {
	return message?.type === ATTENDANCE_FINISHED_NOTIFICATION_TYPE
}

export const SUMMARY_INFO_TOOLTIP_TEXT = "Você pode resumir a conversa clicando em qualquer marco de atendimento dela"

export const CHIP_TEXT_FOR_USER_WITHOUT_IA = "Saiba como obter um resumo do atendimento"
export const CHIP_TEXT_WHEN_SUMMARY_EXISTS = "Ver resumo gerado"
export const CHIP_TEXT_WHEN_NO_SUMMARY = "Gerar resumo com IA"

export const getAttendanceSummaryDialogVariantFromUserRoleName = (userRoleName: UserInInstanceRoleName): AttendanceSummaryDialogVariant => userRoleName === "Gestor" ? "manager" : "attendant"

export {
	isRelevantAttendanceNotificationMessage,
	isAttendanceFinishedNotificationMessage
}
